import { render, staticRenderFns } from "./MyAuthBtn.vue?vue&type=template&id=6d119410&scoped=true"
import script from "./MyAuthBtn.vue?vue&type=script&lang=js"
export * from "./MyAuthBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d119410",
  null
  
)

export default component.exports